export function getNotices({ notices }) {
  return notices.notices;
}

export function getActiveNotice({ notices }) {
  return notices.activeNotice;
}
